import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldSelect } from 'global/components/Form'
import { useCentroCustoOutletContext } from 'pages/CentroCusto.context'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { mapRenderCentros } from '../../mapArvore'

export const FormCentroCusto = ({ isEdicao }: { isEdicao?: boolean }) => {
    const { data } = useCentroCustoOutletContext()

    const { watch } = useFormContext()

    const id = watch('predecessorId')
    const codigo = watch('codigo')

    const predecessor = useMemo(() => {
        if (!id) return null
        return data?.find(item => item.id === id) || null
    }, [data, id])

    return (
        <Grid container>
            <Grid item xs={12}>
                <FormFieldSelect
                    name="predecessorId"
                    label="Nível Superior"
                    required
                    options={[
                        { value: 0, label: 'Nenhum' },
                        ...mapRenderCentros(data).map(node => ({
                            value: node.id,
                            label: (
                                <span
                                    style={{ paddingLeft: node.space * 24 }}
                                >{`${node.codigo} - ${node.nomeCentroCusto}`}</span>
                            ),
                        })),
                    ]}
                />
            </Grid>
            <Grid item xs={4}>
                <FormField
                    name="codigo"
                    label="Código"
                    required
                    {...(!isEdicao
                        ? {
                              startAdornment: (
                                  <span
                                      title={predecessor?.codigo + codigo}
                                      className="mt-1 text-muted-foreground"
                                  >
                                      {predecessor?.codigo}
                                  </span>
                              ),
                              placeholder: '_ _ _ _ _ _',
                              options: {
                                  blocks: [6],
                              },
                          }
                        : {})}
                />
            </Grid>
            <Grid item xs={8}>
                <FormField name="nomeCentroCusto" label="Nome" required />
            </Grid>
            <FormField name="empresaId" hidden />
        </Grid>
    )
}
